import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={26.562}
    height={24.062}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 73716 66779"
    {...props}
  >
    <defs>
      <style>
        {".str1{stroke:#2b2a29;stroke-width:2097.85}.fil1{fill:#1c1b17}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974541830048">
        <path
          d="M27111 25315h45265c-79-3531-4662-14017-6454-18922-815-2231-1366-5082-3834-5082H36026c-2928 0-4749 7165-6568 11948-2468 6488-5940 12056-2347 12056z"
          style={{
            fill: "none",
            stroke: "#2b2a29",
            strokeWidth: 2622.31,
          }}
          className="stroke1"
        />
        <path
          d="M1049 40404c5734-129 9495-3120 13031-5487 0 8810-1145 15900 2581 22108 6453 10754 24596 12809 32196-1049 3296-6010 2258-14887 2258-23802 2777-742 3353-2062 3429-5488h-9602c-3599 0-1261 4600 2057 5488 0 10667 1762 21406-6277 26640-9082 5917-18041 1296-21185-5350-4424-9352 2292-28933-4094-39116-2584-4121-7598-7551-14394-7551v33607z"
          className="fil1"
        />
        <path
          d="M26425 36288c3189 675 2447 15 5504-1344 2789-1238 3793-485 4097-4143-3189-676-2447-14-5504 1342-2788 1239-3792 486-4097 4145zM61403 45889c2178-2607-2305-8389-4116-9601-2853 1602-1783 2334-158 4931 1602 2560 1366 3893 4274 4670zM36026 45889c3065-2052 7650-9601 4115-9601-2224 0-2539 2556-3743 4514-1924 3133-2288 2225-372 5087zM61403 33545c3077 716 8159 5183 8825 1957 624-3023-6117-4701-8825-4701v2744z"
          className="fil1"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
